import type { HTMLChakraProps } from '@chakra-ui/react';
import { forwardRef } from '@chakra-ui/react';
import { chakra } from '@chakra-ui/react';

import { usePromptBarStyles } from '../usePromptBarStyles';

export type PromptBarFooterProps = HTMLChakraProps<'div'>;

/**
 * Footer for PromptBar.
 */
export const PromptBarFooter: React.FC<PromptBarFooterProps> = forwardRef<
  PromptBarFooterProps,
  'div'
>(({ children, ...props }, ref) => {
  const { footer } = usePromptBarStyles();

  return (
    <chakra.div sx={footer} {...props} ref={ref}>
      {children}
    </chakra.div>
  );
});
PromptBarFooter.displayName = 'PromptBarFooter';
